import './typography.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const P = forwardRef((props, ref) => (
  <p ref={ref} className={props.className}>
    {props.children}
  </p>
));

P.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Span = forwardRef((props, ref) => (
  <span ref={ref} className={props.className}>
    {props.children}
  </span>
));

Span.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H1 = forwardRef((props, ref) => {
  const className = classNames({
    h1: true,
    [props.className]: props.className,
  });

  return (
    <h1 ref={ref} className={className}>
      {props.children}
    </h1>
  );
});

H1.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H2 = forwardRef((props, ref) => {
  const className = classNames({
    h2: true,
    [props.className]: props.className,
  });

  return (
    <h2 ref={ref} className={className}>
      {props.children}
    </h2>
  );
});

H2.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H3 = forwardRef((props, ref) => {
  const className = classNames({
    h3: true,
    [props.className]: props.className,
  });

  return (
    <h3 ref={ref} className={className}>
      {props.children}
    </h3>
  );
});

H3.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H4 = forwardRef((props, ref) => {
  const className = classNames({
    h4: true,
    [props.className]: props.className,
  });

  return (
    <h4 ref={ref} className={className}>
      {props.children}
    </h4>
  );
});

H4.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H5 = forwardRef((props, ref) => {
  const className = classNames({
    h5: true,
    [props.className]: props.className,
  });

  return (
    <h5 ref={ref} className={className}>
      {props.children}
    </h5>
  );
});

H5.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const H6 = forwardRef((props, ref) => {
  const className = classNames({
    h6: true,
    [props.className]: props.className,
  });

  return (
    <h6 ref={ref} className={className}>
      {props.children}
    </h6>
  );
});

H6.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Address = forwardRef((props, ref) => (
  <address ref={ref} className={props.className}>
    {props.children}
  </address>
));

Address.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default {
  P,
  Span,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Address,
};
